import { makeStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  container: {
    position: 'relative',
  },
  decorator: {
    position: 'absolute',
    top: 7,
  },
  h1: { top: 30, left: -17, width: 8, height: 73 },
  h2: { top: 19, left: -17, width: 8, height: 45 },
  h3: { top: 15, left: -17, width: 7, height: 35 },
  h4: { top: 11, left: -17, width: 6, height: 26 },
  h5: { top: 8, left: -17, width: 5, height: 19 },
  h6: { top: 8, left: -17, width: 4, height: 17 },

  primary: {
    backgroundColor: theme.palette.primary.main,
  },
  yellow: {
    backgroundColor: '#ffdc25',
  },
  green: {
    backgroundColor: '#15d0c5',
  },
  text: {
    fontFamily: 'sofia-bold',
    width: 'calc(100% - 18px)',
  },
  hText: {
    fontFamily: 'sofia-bold',
  },
  bottomMargin: {
    marginBottom: '16px',
  },
  allCaps: {
    textTransform: 'capitalize',
  },
})

export default makeStyles(styles)
